import {RecordsFilter} from 'core/History';
import {filterHistory} from './filterHistory';

type HistoryFilter = (history: HistoryLog) => HistoryLog;

export function withFilters(...filters: RecordsFilter[]): HistoryFilter {
  return function applyFiltersTo(history: HistoryLog): HistoryLog {
    return filterHistory(history, ...filters);
  };
}
